import { render, staticRenderFns } from "./CombiHeating.vue?vue&type=template&id=fa71f83a"
import script from "./CombiHeating.vue?vue&type=script&lang=ts"
export * from "./CombiHeating.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports